<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  config: {
    type: Object,
    required: true,
  },
  isDefault: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const getDisplayValue = (field, fallback) => {
  if (!field) return fallback;
  if (field.field) return `[${field.field}]`;
  if (field.value) return field.value;
  return fallback;
};
</script>

<template>
  <div
    class="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700"
  >
    <div class="p-3">
      <div class="flex items-start justify-between">
        <div class="flex-1 min-w-0">
          <!-- Title -->
          <h4
            v-if="config.title || isDefault"
            class="font-medium text-sm mb-1 truncate"
            :class="
              isDefault
                ? 'text-slate-400 dark:text-slate-500'
                : 'text-slate-900 dark:text-slate-100'
            "
          >
            {{
              isDefault
                ? t(
                    'LIBRARIES.TEMPLATE_CONFIG.OVERVIEW.DEFAULT_PREVIEW.LIST.TITLE'
                  )
                : getDisplayValue(
                    config.title,
                    t('LIBRARIES.TEMPLATE_CONFIG.PREVIEW_VALUES.LIST_ITEM')
                  )
            }}
          </h4>

          <!-- Description -->
          <p
            v-if="config.description || isDefault"
            class="text-xs line-clamp-2"
            :class="
              isDefault
                ? 'text-slate-400 dark:text-slate-500'
                : 'text-slate-600 dark:text-slate-400'
            "
          >
            {{
              isDefault
                ? t(
                    'LIBRARIES.TEMPLATE_CONFIG.OVERVIEW.DEFAULT_PREVIEW.LIST.DESCRIPTION'
                  )
                : config.description?.field
                  ? t(
                      'LIBRARIES.TEMPLATE_CONFIG.PREVIEW_VALUES.DESCRIPTION_LABEL',
                      {
                        field: config.description.field,
                      }
                    )
                  : t(
                      'LIBRARIES.TEMPLATE_CONFIG.PREVIEW_VALUES.SAMPLE_DESCRIPTION'
                    )
            }}
          </p>
        </div>

        <!-- Action Icon -->
        <Icon
          v-if="config.uri || isDefault"
          icon="i-lucide-chevron-right"
          class="w-4 h-4 ml-2"
          :class="
            isDefault ? 'text-slate-300 dark:text-slate-600' : 'text-slate-400'
          "
        />
      </div>
    </div>
  </div>
</template>
